
import { AppSidebar } from '@/components/AppSidebar';
import { ChatContainer } from '@/components/chat/ChatContainer';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import FAQ from './FAQ';
import Terms from './Terms';
import Privacy from './Privacy';
import Contact from './Contact';

const Index = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchParams] = useSearchParams();
  
  // Handle direct access to chat with chatId parameter
  useEffect(() => {
    const chatId = searchParams.get('chat');
    if (chatId) {
      console.log(`Loading chat with ID: ${chatId} from URL parameter`);
      // The chat loading will be handled by the ChatContainer component
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex flex-col w-full">
      <div className="flex flex-1 overflow-hidden">
        <AppSidebar isOpen={isSidebarOpen} onOpenChange={setIsSidebarOpen} />
        
        <main className="flex-1 relative overflow-hidden bg-black text-white">
          <Routes>
            <Route index element={<ChatContainer />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Index;
